// Components
import { DefaultContentLayout } from '@timeedit/ui-components';
import LogsTable from './LogsTable';
// Styles
import './index.scss';

const getTagColor = (tag: string) => {
  const tagToColorMap: Record<string, string> = {
    success: 'success',
    failure: 'error',
    critical: 'error',
    high: 'warning',
    medium: 'processing',
    low: 'default',
  };

  if (tag.toLowerCase() in tagToColorMap) {
    return tagToColorMap[tag.toLowerCase()];
  }
  return 'default';
};

const SSOLogsPage = () => {
  return (
    <DefaultContentLayout title="Logs">
      <div className="inner-content--wrapper im-mt-1 allow-scroll logs-page">
        <LogsTable />
      </div>
    </DefaultContentLayout>
  );
};

export default SSOLogsPage;
